export default {
    /*!
      初始状态
      */
    // RCCallIdle      =  0,
    /*!
      正在呼出
      */
    RCCallDialing: 1,
    /*!
      正在呼入
      */
    RCCallIncoming: 2,
    /*!
      收到一个通话呼入后，正在振铃
      */
    RCCallRinging: 3,
    /*!
      正在通话
      */
    RCCallActive: 4,
    /*!
      已经挂断
      */
    RCCallHangup: 5,
};
